<script>
    import {LinksManagerConfig} from "../components/links-manager/LinkManagerConfig";
    import { mapState } from "vuex";

    export default {
        name: "LinksMixin",
        data () {
            return {
                linksManagerConfig: LinksManagerConfig,
            }
        },
        computed: {
            ...mapState('user',[
                'latestCourse'
            ]),
            linkTypesUsingAnchors () {
                return this.linksManagerConfig.map( linkOption => {
                    if (linkOption.usesHref) {
                        return linkOption.value;
                    }
                }).filter(linkOption => linkOption);
            },
            getLinkType () {
                return this.myData.linkData && this.myData.linkData.linkType ? this.myData.linkData.linkType : "";
            },
            getLinkTo () {
                return this.myData.linkData && this.myData.linkData.linkTo ? this.myData.linkData.linkTo : "";
            },
            getLinkToExtra () {
                return this.myData.linkData && this.myData.linkData.linkToExtra ? this.myData.linkData.linkToExtra : "";
            },
            getLinkOpen () {
                return this.myData.linkData && this.myData.linkData.linkOpen ? this.myData.linkData.linkOpen : "";
            },
            getLinkData () {
                return this.myData.linkData ? this.myData.linkData : {};
            },
            nodeIsLinked () {
                // TODO review condition
                return this.myData.linkData && this.myData.linkData.linkType;
            },
            nodeToLinkify() {
                // Allows us to change which node we want to attach an anchor
                // regardless of where the sideform prop exists (e.g. from a wrapper)
                // by overriding this computed property.
                return this.myNode;
            },
        },
        methods: {
            setLinkAttribute (data) {
                let linkData = {
                    linkType: this.getLinkType,
                    linkTo: this.getLinkTo,
                    linkToExtra: this.getLinkToExtra,
                    linkOpen: this.getLinkOpen,
                };

                let linkAttr = data.attribute;
                let linkValue = data.value;



                if (linkAttr === "linkType") {
                    linkData = {
                        linkType: "",
                        linkTo: "",
                        linkToExtra: "",
                        linkOpen: "",
                    }; //reset other choices
                }

                if (linkValue) {
                    linkData[linkAttr] = linkValue;

                    if (this.linkTypesUsingAnchors.includes(linkData.linkType)) {

                        if (!this.getClosestAnchor() ) {
                            this.wrapNodeInAnchor();
                        }

                        this.setAnchorAttributes(linkData);

                    } else if (this.getClosestAnchor()){
                        this.unwrapNodeFromAnchor();
                    }


                }
                else if (!linkValue && linkAttr === "linkType" && this.getClosestAnchor()) {
                    this.unwrapNodeFromAnchor();
                }
                if(linkAttr == 'forceRerender'){
                    return;
                }

                let dataChangeTarget = this;
                if (this.nodeToLinkify !== this.myNode) {
                    dataChangeTarget = this.findNodeState(this.nodeToLinkify.id)
                }

                dataChangeTarget.changeMyData({linkData});;
            },
            setAnchorAttributes (linkData) {
                let wrapper = this.getClosestAnchor();

                wrapper.setAttribute("href", this.createHrefForLink(linkData));

                if (linkData.linkOpen === "new") {
                    wrapper.setAttribute("target" , "_blank")
                } else {
                    wrapper.removeAttribute("target")
                }
            },
            wrapNodeInAnchor () {
                let wrapper = document.createElement("a");
                wrapper.classList.add(this.classSelectors.linkedNode);

                if (wrapper) {
                    this.nodeToLinkify.parentNode.replaceChild(wrapper, this.nodeToLinkify);
                    wrapper.appendChild(this.nodeToLinkify);

                }
            },
            unwrapNodeFromAnchor () {
                let anchor = this.getClosestAnchor();
                let anchorParentNode = anchor.parentNode;

                while (anchor.firstChild) {
                    anchorParentNode.insertBefore(anchor.firstChild, anchor);
                }

                anchorParentNode.removeChild(anchor);
            },
            createHrefForLink (linkData) {

                let selectedLinkType = linkData && linkData.linkType ? linkData.linkType : "";
                let selectedLinkTo = linkData && linkData.linkTo ? linkData.linkTo : "";
                let selectedLinkToExtra = linkData && linkData.linkToExtra ? linkData.linkToExtra: "";
                let hrefBase = "";

                if (selectedLinkType==='signout') {
                    return '/signout';
                }

                if (selectedLinkType) {
                    this.linksManagerConfig.find( linkType => {
                        if (linkType.value === selectedLinkType && !hrefBase) {

                            if (linkType.hrefValue) {

                                hrefBase = linkType.hrefValue;
                                return true;
                            } else if (linkType.linkToExtraOptions) {


                                linkType.linkToExtraOptions.find( linkToExtraOption => {

                                    if (linkToExtraOption.value === selectedLinkToExtra && linkToExtraOption.hrefValue) {
                                        hrefBase = linkToExtraOption.hrefValue;
                                        return true;
                                    }

                                    if (!hrefBase && linkToExtraOption.isDefault && linkToExtraOption.hrefValue) {
                                        hrefBase = linkToExtraOption.hrefValue;
                                    }
                                })
                            }  else if (linkType.data ) {

                                linkType.data.find( linkToOption => {

                                    if (linkToOption.value === selectedLinkTo && linkToOption.hrefValue) {
                                        hrefBase = linkToOption.hrefValue;
                                        return true;
                                    }
                                })
                            }
                        }
                    })
                }

                hrefBase = hrefBase.replace("{x}" , selectedLinkTo);
                hrefBase = hrefBase.replace("{y}" , selectedLinkToExtra);

                return hrefBase;
            },
            getClosestAnchor () {
                return this.nodeToLinkify.closest(`a.${this.classSelectors.linkedNode}`);
            },
            handleLinkSelection (linkData) {
                let key = linkData ? linkData.linkType : this.getLinkType;

                if (key === "socialNetwork") {
                    return this.redirectToSocialNetwork(linkData);
                } else if (key === "scrolllink") {
                    return this.scrollToSelectedSection(linkData);
                } else if (key === "openformslink") {
                    return this.openForm(linkData);
                } else if (key === "signout") {
                    window.location.href = "/signout";
                } else if (key === 'socialShare') {
                    return this.handleSocialShare(linkData);
                } else if (key === 'resumeCourse' && this.latestCourse){
                     window.location.href = `/path-player?courseid=${this.latestCourse}`;                    
                } else if (key === 'afterPurchase') {
                    return this.redirectToAfterPurchaseOption(linkData);
                } else {
                   let url = this.createHrefForLink(this.myData.linkData);
                   if(!url || !url.length){
                       return;
                   }
                   let newWidow = this.myData?.linkData?.linkOpen !== "default";
                   if(newWidow){
                       window.open(url, "_blank");
                   }else{
                       window.location.href = url;
                   }                    
                }
            },
            redirectToAfterPurchaseOption (linkData) {
                let afterPurchaselinkType = linkData ? linkData.linkTo : this.getLinkTo;
                let target = linkData ? linkData.linkOpen : this.getLinkOpen;

                if (afterPurchaselinkType === 'productPage') {
                    return this.getProductCourseUrl('coursePage');
                } else if (afterPurchaselinkType === 'pathPlayer') {
                    return this.getProductCourseUrl('pathPlayer');
                } else {
                    const redirectUrl = '?start=1';

                    if (target === "new") {
                        return window.open(redirectUrl);
                    }
                    window.location.href = redirectUrl;
                }
            },
            getProductCourseUrl (urlType) {

                //Get Product Id and product type from url
                //For now we are using this only in Thank you zones
                var productId = $.getURLvar('product_id');
                var productType = $.getURLvar('product_type');
                if(typeof productId == 'undefined' ||  typeof productType == 'undefined' ){
                    return false;
                }

                $.ajax({
                    url: server+"product_course/" + productId + "/" + productType + "/url/" + urlType,
                    async: true,
                    type: "GET",
                    dataType: 'json',
                    success: function (data) {
                        console.log('data : ', data);
                        if (data.success) {
                            if(typeof data.url !== 'undefined'){
                                $(document.createElement("a")).appendTo($("body")).attr("href", data.url).attr("target", "_self")[0].click();
                            }
                        } else {
                            displayError(data.errors);
                        }
                    },
                    error: function () {
                        displayError('NO DATA');
                    }
                });

            },
            redirectToSocialNetwork (linkData) {
                let redirectUrl = "";
                let key = linkData ? linkData.linkTo : this.getLinkTo;
                let target = linkData ? linkData.linkOpen : this.getLinkOpen;

                if (key === "facebook") {
                    redirectUrl = window.SITE_SOCIAL_FACEBOOK;
                } else if ( key === "twitter") {
                    redirectUrl = window.SITE_SOCIAL_TWITTER;
                } else if ( key === "linkedin") {
                    redirectUrl = window.SITE_SOCIAL_LINKEDIN;
                }

                if (target === "new") {
                    return window.open(redirectUrl,'_blank');
                }



                window.location.href = redirectUrl;
            },
            openForm (linkData) {
                let key = linkData ? linkData.linkTo : this.getLinkTo;

                let ssoKeyMap = {
                    "signin" : "login",
                    "signup" : "signup",
                    "resetpassword" : "passwordreset",
                };

                let redirectKeyMap = {
                    "signin" : "not-logged-in",
                    "signup" : "signup",
                    "resetpassword" : "resetpassword",
                };

                let ssoKey = ssoKeyMap[key] ? ssoKeyMap[key] : "login";
                let redirectKey = redirectKeyMap[key] ? redirectKeyMap[key] : "not-logged-in";

                if (window.checkAndRedirectForSSO(ssoKey)) {
                    return;
                }

                if (!key) {
                    return;
                }

                if (l_settings) {

                    if (key=== "signin") {
                        l_settings.showEnterOnlyForm();
                    } else if (key === "signup") {
                        l_settings.signup = 'learnworlds';
                        //l_settings.courseRegister = true;
                        l_settings.showRegisterForm();

                    } else if (key === "resetpassword") {
                        l_settings.showPasswordResetForm();
                    }

                } else {
                    document.location.href= "/?msg=" + redirectKey;
                }
            },
            scrollToSelectedSection (linkData) {
                let sectionId = linkData ? linkData.linkTo : this.getLinkTo;

                if (!sectionId || ( sectionId && !this.sectionStates[sectionId]) ) {
                    return;
                }

                // document.getElementById(sectionId).scrollIntoView({
                //     behavior: "smooth",
                //     block: "end",
                //     inline: "nearest"
                // });
                window.scrollTo({
                    top: document.getElementById(sectionId).offsetTop,
                    behavior: "smooth"
                })

                // $('body,html').animate({scrollTop: this.sectionStates[sectionId].sectionNode.offsetHeight});
            },

            handleSocialShare (linkData) {
                const socialNetwork = (linkData ? linkData.linkTo : this.getLinkTo) || false;
                const title = document.title;
                const source = document.URL;
                return socialNetwork ? this.shareTo(socialNetwork, title, source): '';
            },
            shareTo (socialNetwork, title, source) {
                let url, windowName;

                switch (socialNetwork) {
                    case 'twitter':
                        url = "https://twitter.com/intent/tweet?text=" + encodeURIComponent(title) + "&url=" + encodeURIComponent(source);
                        break;
                    case 'facebook':
                        url = "http://www.facebook.com/sharer.php?u=" + encodeURIComponent(source)+ "&p=" + encodeURIComponent(title);
                        break;
                    case 'linkedin':
                        url = "https://www.linkedin.com/shareArticle?mini=true&url=" + encodeURIComponent(source) + "&title=" + encodeURIComponent(title);
                        break;
                    case 'pinterest':
                        windowName = 'PinterestWindow';
                        url = "https://pinterest.com/pin/create/button/?url=" + encodeURIComponent(source) + "&description=" + encodeURIComponent(title); // needs &media={image.url}
                        break;
                    default:
                        url = false;
                        break;
                }
                if (url) {
                    const windowParams = 'scrollbars=0, resizable=1, menubar=0, left=100, top=100, width=550, height=440, toolbar=0, status=0';
                    window.open(url, windowName, windowParams);
                }
            }
        }
    }
</script>

